import { useDispatch } from 'react-redux';
import content from '../../../../redux/reducer/content';

export default function useOnboardingCallbacks() {
  const dispatch = useDispatch();

  return {
    setCompletedStepsData: (data) => dispatch(content.actions.setCompletedStepsData(data)),
    setOnboardingStarted: (value) => dispatch(content.actions.setOnboardingStarted(value)),
    setCurrentOnboardingStep: (value) => dispatch(content.actions.setCurrentOnboardingStep(value)),
    addCurrentStepToCompleted: () => dispatch(content.actions.addCurrentStepToCompleted()),
    resetOnboardingState: () => dispatch(content.actions.resetOnboardingState()),
    setUserModalsVisibility: (value) => dispatch(content.actions.setUserModalsVisibility(value)),
    setMarchModalsVisibility: (value) => dispatch(content.actions.setMarchModalsVisibility(value)),
  };
}
